export default __webpack_public_path__ + "static/media/retain3.4a32538f.svg";